import {SortSchema} from '@cypro/ui/schemas'
import {Status} from '@cypro/engine/schema'
import * as z from 'zod'

export const NewDrugsCategoryPageSearchSchema = z.object({
  categoryId: z.uuidv7().optional(),
})

export const DrugsCategoriesSearchSchema = z.object({
  filters: z.object({search: z.string().optional()}).optional(),
  sort: z.array(SortSchema).default([{id: 'name', desc: false}]),
})

export const DrugsCategorySchema = z.object({
  id: z.uuidv7().optional(),
  name: z.string().trim().nonempty(),
  description: z.string(),
  status: Status,
})
export type DrugsCategorySchema = z.infer<typeof DrugsCategorySchema>

export const DrugsCategoryFormSchema = DrugsCategorySchema.extend({
  subcategories: z.array(DrugsCategorySchema),
})
export type DrugsCategoryFormSchema = z.infer<typeof DrugsCategoryFormSchema>
